// Control-pane refresh driver. Non-UI code dispatches 'ui:pane:refresh' after
// changing params; this listener is the only place that knows the UI is
// the pane (the .refresh() call). Pane state lives in src/ui/panel/state.ts.

import { paneState } from './panel/state';
import { INTENTS } from '../store/intents';
import type { Store } from '../store/store';
import type { State } from '../store/schema';

export function installPaneRefreshDriver(store: Store<State>): () => void {
    return store.onIntent(INTENTS.UI_PANE_REFRESH, () => {
        const inst = paneState.instance as { refresh?: () => void } | null;
        inst?.refresh?.();
    });
}
